export default function CsharpBoolType() {
  return (
    <h2>Csharp Bool Type</h2>
  );
}
